<template>
    <div class="scene">
        <div class="headline">{{ $t('headline.title2') }}</div>
        <div class="scenes">
            <div class="sceneItem" v-for="(item, index) in 6">
                <img :src="`https://4d-ai.chat/img/yycj${index + 1}.jpg`">
                <div class="txt">
                    <div class="title">{{ $t(`scenarios.title${index + 1}`) }}</div>
                    <div class="content">{{ $t(`scenarios.content${index + 1}`) }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {}
    },
    mounted() {

    },
    methods: {}
}
</script>
<style scoped>
@media (max-width: 768px) {
    .headline {
        font-size: 18px !important;
        margin-bottom: 10px !important;
    }

    .scene {
        padding: 10px !important;
    }

    .sceneItem {
        width: 100% !important;
        margin-bottom: 10px !important;
        border-radius: 15px !important;
    }

    .title {
        font-size: 12px !important;
    }

    .content {
        font-size: 12px !important;
    }

    .txt {
        padding: 10px !important;
        box-sizing: border-box !important;
    }

    .sceneItem:nth-child(6) {
        margin-bottom: 0 !important;
    }
}
</style>
<style scoped lang="less">
.headline {
    font-weight: 600;
    font-size: 36px;
    color: #243c8a;
    text-align: center;
    margin-bottom: 64px;
}

.scene {
    background-color: #fff;
    padding: 80px 212px;
    box-sizing: border-box;

    .scenes {
        display: flex;
        flex-wrap: wrap;

        .sceneItem:hover {
            box-shadow: 0 2px 50px #0000001a;
            transform: translate(0, -10px)
        }

        .sceneItem:nth-child(4) {
            margin-bottom: 0;
        }

        .sceneItem:nth-child(5) {
            margin-bottom: 0;
        }

        .sceneItem:nth-child(6) {
            margin-bottom: 0;
        }

        .sceneItem:nth-child(3n) {
            margin-right: 0;
        }

        .sceneItem {
            width: calc(33% - 20px);
            background-color: #fff;
            box-shadow: 0 2px 8px #0000001a;
            border-radius: 15px;
            overflow: hidden;
            box-sizing: border-box;
            transition: all 0.3s;
            margin-bottom: 30px;
            margin-right: 30px;

            .txt {
                background-color: #fff;
                padding: 24px;
                box-sizing: border-box;

                .title {
                    font-size: 20px;
                    font-weight: 600;
                    color: #243c8a;
                    margin-bottom: 12px;
                }

                .content {
                    font-size: 16px;
                    color: #4c5563;
                }
            }

            img {
                width: 100%;
            }
        }
    }
}
</style>